import { useState } from 'react'
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap'
import InputMask from 'react-input-mask'
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPaperPlane,
} from 'react-icons/fa'

const FORM_INICIAL = { nome: '', fone: '', email: '', assunto: '', mensagem: '' }

const ASSUNTOS = [
  'Informações gerais',
  'Filiação / Associação',
  'Benefícios',
  'Jurídico / Trabalhista',
  'Convenção Coletiva',
  'Jornal do Sindicato',
  'Imprensa',
  'Outro',
]

// eslint-disable-next-line react/prop-types
function InfoItem({ icon, children }) {
  return (
    <div className="contato-info-item">
      <span className="contato-info-icon">{icon}</span>
      <span>{children}</span>
    </div>
  )
}

function Contato() {
  const [form, setForm] = useState(FORM_INICIAL)
  const [errors, setErrors] = useState({})
  const [enviado, setEnviado] = useState(false)
  const [enviando, setEnviando] = useState(false)

  const set = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }))
    if (errors[field]) setErrors(prev => { const e = { ...prev }; delete e[field]; return e })
  }

  const validate = () => {
    const e = {}
    if (!form.nome.trim())    e.nome = 'Campo obrigatório'
    const foneDigits = form.fone ? form.fone.replaceAll(/\D/gu, '') : ''
    if (foneDigits.length < 10) e.fone = 'Telefone inválido'
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'E-mail inválido'
    if (!form.assunto)        e.assunto = 'Selecione um assunto'
    if (!form.mensagem.trim() || form.mensagem.trim().length < 10) e.mensagem = 'Mensagem muito curta (mínimo 10 caracteres)'
    return e
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const erros = validate()
    if (Object.keys(erros).length > 0) { setErrors(erros); return }

    setEnviando(true)
    await new Promise(r => setTimeout(r, 800))
    setEnviando(false)
    setEnviado(true)
    setForm(FORM_INICIAL)
    setErrors({})
  }

  return (
    <Container>
      <div style={{ marginTop: '2rem', marginBottom: '3rem' }}>

        {/* ── Cabeçalho da página ── */}
        <Row className="mb-4">
          <Col xs={12}>
            <h2 className="section-title">Fale Conosco</h2>
            <p className="text-muted">
              Entre em contato com o Sindicato dos Metalúrgicos de Bauru e Região.
              Estamos prontos para atender você.
            </p>
          </Col>
        </Row>

        <Row className="g-4">

          {/* ── Coluna esquerda: informações + mapa ── */}
          <Col xs={12} lg={5}>

            {/* Card de informações */}
            <div className="contato-info-card mb-4">
              <h5 className="contato-card-title">Informações de Contato</h5>

              <InfoItem icon={<FaMapMarkerAlt />}>
                Rua Araújo Leite, 2-25 — Centro<br />
                Bauru/SP — CEP 17010-180
              </InfoItem>

              <InfoItem icon={<FaPhoneAlt />}>
                <a href="tel:+551432324367" className="contato-link">(14) 3232-4367</a>
              </InfoItem>

              <InfoItem icon={<FaWhatsapp />}>
                <a
                  href="https://wa.me/5514993187501"
                  target="_blank"
                  rel="noreferrer"
                  className="contato-link"
                >
                  (14) 99318-7501
                </a>
              </InfoItem>

              <InfoItem icon={<FaEnvelope />}>
                <a href="mailto:sindimetalurgicos@uol.com.br" className="contato-link">
                  sindimetalurgicos@uol.com.br
                </a>
              </InfoItem>

              <InfoItem icon={<FaClock />}>
                <span>
                  Segunda a sexta: <strong>8h às 17h</strong>
                </span>
              </InfoItem>
            </div>

            {/* Card de redes sociais */}
            <div className="contato-info-card mb-4">
              <h5 className="contato-card-title">Redes Sociais</h5>
              <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                Acompanhe as notícias e comunicados nas nossas redes.
              </p>
              <div className="contato-social-grid">
                <a
                  href="https://www.facebook.com/smetalbauru"
                  target="_blank"
                  rel="noreferrer"
                  className="contato-social-btn contato-social-facebook"
                >
                  <FaFacebookF className="me-2" /> Facebook
                </a>
                <a
                  href="https://www.instagram.com/metalbauru"
                  target="_blank"
                  rel="noreferrer"
                  className="contato-social-btn contato-social-instagram"
                >
                  <FaInstagram className="me-2" /> Instagram
                </a>
                <a
                  href="https://wa.me/5514993187501"
                  target="_blank"
                  rel="noreferrer"
                  className="contato-social-btn contato-social-whatsapp"
                >
                  <FaWhatsapp className="me-2" /> WhatsApp
                </a>
              </div>
            </div>

            {/* Google Maps */}
            <div className="contato-map-wrapper">
              <iframe
                title="Localização Sindicato dos Metalúrgicos de Bauru"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3698.1!2d-49.0644!3d-22.3156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bf71a0b6ef3c5d%3A0x7c1c0d1c2b3a4e5f!2sRua%20Ara%C3%BAjo%20Leite%2C%202-25%20-%20Centro%2C%20Bauru%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1680000000000!5m2!1spt-BR!2sbr"
                width="100%"
                height="240"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Col>

          {/* ── Coluna direita: formulário ── */}
          <Col xs={12} lg={7}>
            <div className="contato-form-card">
              <h5 className="contato-card-title">Envie uma Mensagem</h5>
              <p className="text-muted mb-4" style={{ fontSize: '0.875rem' }}>
                Preencha o formulário abaixo e responderemos em até 2 dias úteis.
              </p>

              {enviado && (
                <Alert variant="success" onClose={() => setEnviado(false)} dismissible className="mb-4">
                  <strong>Mensagem enviada!</strong> Em breve entraremos em contato.
                </Alert>
              )}

              <Form noValidate onSubmit={handleSubmit}>
                <Row className="g-3">

                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Nome completo *</Form.Label>
                      <Form.Control
                        value={form.nome}
                        onChange={e => set('nome', e.target.value)}
                        isInvalid={!!errors.nome}
                        placeholder="Seu nome completo"
                      />
                      <Form.Control.Feedback type="invalid">{errors.nome}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Telefone *</Form.Label>
                      <Form.Control
                        as={InputMask}
                        mask="(99) 99999-9999"
                        value={form.fone}
                        onChange={e => set('fone', e.target.value)}
                        isInvalid={!!errors.fone}
                        placeholder="(14) 99999-9999"
                      />
                      <Form.Control.Feedback type="invalid">{errors.fone}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">E-mail *</Form.Label>
                      <Form.Control
                        type="email"
                        value={form.email}
                        onChange={e => set('email', e.target.value)}
                        isInvalid={!!errors.email}
                        placeholder="seuemail@exemplo.com"
                      />
                      <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Assunto *</Form.Label>
                      <Form.Select
                        value={form.assunto}
                        onChange={e => set('assunto', e.target.value)}
                        isInvalid={!!errors.assunto}
                      >
                        <option value="">Selecione um assunto...</option>
                        {ASSUNTOS.map(a => <option key={a} value={a}>{a}</option>)}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">{errors.assunto}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Mensagem *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        value={form.mensagem}
                        onChange={e => set('mensagem', e.target.value)}
                        isInvalid={!!errors.mensagem}
                        placeholder="Descreva sua dúvida, sugestão ou solicitação..."
                        style={{ resize: 'vertical' }}
                      />
                      <Form.Control.Feedback type="invalid">{errors.mensagem}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} className="pt-1">
                    <Button
                      type="submit"
                      className="btn-primary-red border-0 d-inline-flex align-items-center gap-2 px-4"
                      size="lg"
                      disabled={enviando}
                    >
                      {enviando
                        ? <><span className="spinner-border spinner-border-sm" /> Enviando...</>
                        : <><FaPaperPlane /> Enviar mensagem</>
                      }
                    </Button>
                  </Col>

                </Row>
              </Form>
            </div>
          </Col>

        </Row>
      </div>
    </Container>
  )
}

export default Contato